import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trash2, Plus } from "lucide-react";
import { toast } from "sonner";

export default function AdminMaterials() {
  const [list, setList] = useState([]);
  const [name, setName] = useState("");
  const load = () => api.get("/admin/materials").then(({ data }) => setList(data));
  useEffect(() => { load(); }, []);

  const save = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await api.post("/admin/materials", { name: name.trim() });
      toast.success("Material adicionado");
      setName(""); load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Erro"); }
  };
  const del = async (id) => { if (window.confirm("Remover material?")) { await api.delete(`/admin/materials/${id}`); load(); } };

  return (
    <div data-testid="admin-materials">
      <h1 className="font-display text-3xl text-[#49392F] mb-2">Materiais</h1>
      <p className="text-[13px] text-[#49392F]/70 mb-8">
        Materiais aparecem como filtro no catálogo e ficam disponíveis ao cadastrar produtos.
      </p>

      <form onSubmit={save} className="bg-white border border-[#C2A064]/20 p-5 flex gap-3 mb-8">
        <input
          className="duo-input flex-1"
          placeholder="Ex.: Prata 925, Folheado a ouro, Aço cirúrgico..."
          value={name}
          onChange={(e) => setName(e.target.value)}
          data-testid="material-name-input"
        />
        <button className="duo-btn duo-btn-primary" data-testid="material-save-button">
          <Plus size={14} /> Adicionar
        </button>
      </form>

      <div className="bg-white border border-[#C2A064]/20">
        {list.length === 0 && <div className="p-6 text-center text-[#49392F]/60">Nenhum material cadastrado.</div>}
        {list.map((m) => (
          <div key={m.id} className="flex items-center justify-between p-4 border-b border-[#C2A064]/10 last:border-0">
            <div className="text-[14px] text-[#49392F]">{m.name}</div>
            <button onClick={() => del(m.id)} className="p-2 text-[#49392F]/60 hover:text-[#49392F]" aria-label="remover" data-testid={`delete-mat-${m.id}`}>
              <Trash2 size={14} />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
